import { Component } from '@angular/core'
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms'
import { PublicPageTitleService } from '@public/app/services/public-page-title.service'
import { AuthService } from '@shared/services/auth.service'
import { Router } from '@angular/router'
import { GameDataService } from '@shared/services/game-data.service'

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss'],
  standalone: false,
})
export class RegisterPageComponent {
  registerForm: UntypedFormGroup
  pageTitle = 'Regisztráció'

  constructor(
    private publicPageTitleService: PublicPageTitleService,
    private authService: AuthService,
    private gameDataService: GameDataService,
    private router: Router
  ) {
    this.registerForm = new UntypedFormGroup({
      name: new UntypedFormControl('', Validators.required),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      password: new UntypedFormControl('', Validators.required),
      confirmPassword: new UntypedFormControl('', Validators.required),
      isPrivacyPolicyAccepted: new UntypedFormControl(false, Validators.requiredTrue),
      isTermsAndConditionsAccepted: new UntypedFormControl(false, Validators.requiredTrue),
    })
    this.publicPageTitleService.setPageTitle(this.pageTitle)
  }

  onRegister(): void {
    if (!this.registerForm.valid) {
      return
    }

    if (this.registerForm.value.password !== this.registerForm.value.confirmPassword) {
      console.log('Missing feature: handle password mismatch error')
      return
    }

    this.authService
      .createUserWithEmailAndPassword(
        this.registerForm.value.name,
        this.registerForm.value.email,
        this.registerForm.value.password
      )
      .then(cred => {
        if (cred.user) {
          this.gameDataService.savePlayerAgreements(
            cred.user.uid,
            this.registerForm.value.isPrivacyPolicyAccepted,
            this.registerForm.value.isTermsAndConditionsAccepted
          )
        }
        console.log('Missing feature: handle successful registration UI feedback')
        this.router.navigate(['/'])
      })
      .catch(error => {
        console.error('Registration error:', error)
      })
  }

  navigateToLogin(): void {
    this.router.navigate(['/login'])
  }
}
